import styled from 'styled-components';
export const Container = styled.div `
  display: grid;
  gap: 16px;
  justify-items: flex-start;
`;
export const FieldsetContainer = styled.div `
  width: 100%;
`;
export const TagSelectContainer = styled.div `
  width: 100%;
`;
